import { render } from "./SwitchingBar.vue?vue&type=template&id=04cef7ae&scoped=true"
import script from "./SwitchingBar.vue?vue&type=script&lang=js"
export * from "./SwitchingBar.vue?vue&type=script&lang=js"

import "./SwitchingBar.vue?vue&type=style&index=0&id=04cef7ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04cef7ae"]])

export default __exports__